import React from 'react';
import Icon from '@common/assets';
import UpdateButton from '@components/profile/profileOverlay/overlays/common/updateBtn';
import AddButton from '@components/profile/profileOverlay/overlays/common/addBtn';
import { ProjectStateType } from '@components/profile/profileOverlay/overlays/project/index';
import ProfileProjectsVO, { ProfileProjectVO } from '@domain/vo/profile/ProfileProjectVO';
import Colors from '@domain/constant/colors';
import classnames from 'classnames/bind';
import styles from './project.module.scss';

const cx = classnames.bind(styles);

interface ProjectListProps {
  profileProjects?: ProfileProjectsVO;
  setProjectState: (projectState: ProjectStateType) => void;
  setProject: (project: ProfileProjectVO | null) => void;
  setProjectIndex: (projectSn: number | null) => void;
  onClose: () => void;
}

const ProjectList = ({ profileProjects, setProject, setProjectIndex, setProjectState, onClose }: ProjectListProps) => {
  const isExist = !!profileProjects?.projects?.length;

  const handleExit = () => onClose();
  const writeNewProject = () => {
    setProject(null);
    setProjectIndex(null);
    setProjectState('FORM');
  };

  const listEls = profileProjects?.projects?.map((project, index) => {
    const { title, startDate, endDate } = project;
    const handleClick = () => {
      setProject(project);
      setProjectIndex(index);
      setProjectState('FORM');
    };

    return (
      <li key={index} className={cx('listItem')}>
        <a className={cx('btnList')} role="button" onClick={handleClick}>
          <div className={cx('contentsArea')}>
            <span className={cx('listText')}>{title}</span>
            <span className={cx('listDesc')}>
              {startDate} ~ {endDate}
            </span>
          </div>
          <Icon name="arrowRightLight" width={40} height={40} />
        </a>
      </li>
    );
  });

  const getContentsEl = () => {
    if (isExist) {
      return (
        <>
          <div className={cx('addBtnArea')}>
            <AddButton
              theme={'dark'}
              beforeIcon={<Icon name={'addLight'} fill={Colors.C_WHITE} width={24} height={24} />}
              text={'프로젝트 추가하기'}
              onClick={writeNewProject}
            />
          </div>

          <ul className={cx('list')}>{listEls}</ul>

          <div className={cx('updateBtnArea')}>
            <UpdateButton onClick={() => setProjectState('DELETE')} disabled={!isExist} />
          </div>
        </>
      );
    }

    return (
      <AddButton
        type={'large'}
        beforeIcon={<Icon name={'addLight'} fill={Colors.C_BLACK} width={32} height={32} />}
        afterIcon={<Icon name={'arrowRightLight'} fill={Colors.C_BLACK} width={40} height={40} />}
        text={'프로젝트 추가하기'}
        onClick={writeNewProject}
      />
    );
  };

  return (
    <>
      <div className={cx('scrollArea')}>
        <div className={cx('scrollInner')}>
          <div className={cx('scrollWrap')}>
            <div className={cx('listArea')}>{getContentsEl()}</div>
          </div>
        </div>
      </div>

      <div className={cx('btnArea')}>
        <a className={cx('btn', 'cancel')} role="button" onClick={handleExit}>
          나가기
        </a>
      </div>
    </>
  );
};

export default ProjectList;
